import { render, staticRenderFns } from "./LearningModule.vue?vue&type=template&id=066518e0"
import script from "./LearningModule.vue?vue&type=script&lang=js"
export * from "./LearningModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports